import { Component, Input, OnDestroy, forwardRef } from '@angular/core';
import { ControlValueAccessor, FormControl, FormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Subscription } from 'rxjs';
import utils from 'src/app/utils/utils';

@Component({
  selector: 'custom-editor-accesor',
  templateUrl: './custom-editor-accesor.component.html',
  styleUrls: ['./custom-editor-accesor.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(()=> CustomEditorAccesorComponent),
      multi: true
    }
  ]
})
export class CustomEditorAccesorComponent implements ControlValueAccessor, OnDestroy {

  value = new FormControl(['', [], []]);
  subscriptions: Subscription[] = [];
  @Input() placeholder?: string;
  @Input() form?: FormGroup;
  @Input() inputName?: string;

  writeValue(input: any): void {
    this.value.setValue(input);
  }
  propagateChange: any = (f:any) =>{}
  onTouch: any = () => {}

  registerOnChange(fn: any): void {
    this.subscriptions.push(
      this.value.valueChanges.subscribe(fn)
    );
  }
  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  registerOnTouched(fn: any){
    this.onTouch = fn;
  }

  isValidField(){
    return utils.isValidFieldForm(this.form!, this.inputName!)
  }
  errorField(){
    return utils.getFieldErrorForm(this.form!, this.inputName!)
  }
}
